<template>
  <div class="futures-data">
    <!-- <div class="futures-list"> -->
      <!-- <div class="item">
        <div>{{lastDate.day}}</div>
        <div>{{lastDate.year}}</div>
      </div> -->
      <!-- <div v-for="(item, i) in lastData" 
            :key="i" 
            class="item item-data"
            @click="toMore(item)">
        <div>{{item.name}}</div>
        <div class="value" 
              :style="{color: Number(item.todaySettle) < Number(item.yesterdaySettle) ? 'green' :
                      Number(item.todaySettle) > Number(item.yesterdaySettle) ? 'red' : ''}">
          <span>{{item.todaySettle}}</span>
          <span v-if="Number(item.yesterdaySettle) && Number(item.todaySettle)">
            <i v-if="Number(item.todaySettle) > Number(item.yesterdaySettle)" style="color: red" class="el-icon-top"></i>
            <i v-if="Number(item.todaySettle) < Number(item.yesterdaySettle)" style="color: green" class="el-icon-bottom"></i>
            {{Math.abs(Number(((item.todaySettle - item.yesterdaySettle) / item.yesterdaySettle * 100).toFixed(2)))}}%
          </span>
        </div>
      </div> -->
    <!-- </div> -->

    <index-card @changeData="changeData" :lastDate="lastDate"></index-card>

    <div style="padding: 11px 10px 1px;margin-bottom: 20px;">
      <el-row style="margin-bottom: 10px;"
              :gutter="10">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <datatable :tagData="futuresTag"
                      :tabData="futuresData1">
            <template slot="contractCode" slot-scope="prop">
              <span class="contract-code" @click="toMoreRow(prop.row)">{{prop.row.contractCode}}</span>
            </template>

            <template slot="rate" slot-scope="prop">
              <span class="table-cell-span"
                    v-if="Number(prop.row.yesterdaySettle) && Number(prop.row.todaySettle)"
                    :style="{color: Number(prop.row.todaySettle) < Number(prop.row.yesterdaySettle) ? 'green' :
                                    Number(prop.row.todaySettle) > Number(prop.row.yesterdaySettle) ? 'red' : ''}">
                {{Number(((prop.row.todaySettle - prop.row.yesterdaySettle) / prop.row.yesterdaySettle * 100).toFixed(2))}}%
              </span>
            </template>
          </datatable>

          <priceTrend v-if="futuresData1&&futuresData1.length>0" 
                      ref="priceTrend1"
                      :trendItem="futuresData1"
                      :title="lastDate.date"
                      :yTitle="lastData[0].name"
                      chartId="priceTrend1"></priceTrend>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <datatable :tagData="futuresTag"
                      :tabData="futuresData2">
            <template slot="contractCode" slot-scope="prop">
              <span class="contract-code" @click="toMoreRow(prop.row)">{{prop.row.contractCode}}</span>
            </template>

            <template slot="rate" slot-scope="prop">
              <span class="table-cell-span"
                    v-if="Number(prop.row.yesterdaySettle) && Number(prop.row.todaySettle)"
                    :style="{color: Number(prop.row.todaySettle) < Number(prop.row.yesterdaySettle) ? 'green' :
                                    Number(prop.row.todaySettle) > Number(prop.row.yesterdaySettle) ? 'red' : ''}">
                {{Number(((prop.row.todaySettle - prop.row.yesterdaySettle) / prop.row.yesterdaySettle * 100).toFixed(2))}}%
              </span>
            </template>
          </datatable>

          <priceTrend v-if="futuresData2&&futuresData2.length>0" 
                      ref="priceTrend2"
                      :trendItem="futuresData2"
                      :title="lastDate.date"
                      :yTitle="lastData[1].name"
                      chartId="priceTrend2"></priceTrend>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <datatable :tagData="futuresTag"
                      :tabData="futuresData3">
            <template slot="contractCode" slot-scope="prop">
              <span class="contract-code" @click="toMoreRow(prop.row)">{{prop.row.contractCode}}</span>
            </template>

            <template slot="rate" slot-scope="prop">
              <span class="table-cell-span"
                    v-if="Number(prop.row.yesterdaySettle) && Number(prop.row.todaySettle)"
                    :style="{color: Number(prop.row.todaySettle) < Number(prop.row.yesterdaySettle) ? 'green' :
                                    Number(prop.row.todaySettle) > Number(prop.row.yesterdaySettle) ? 'red' : ''}">
                {{Number(((prop.row.todaySettle - prop.row.yesterdaySettle) / prop.row.yesterdaySettle * 100).toFixed(2))}}%
              </span>
            </template>
          </datatable>

          <priceTrend v-if="futuresData3&&futuresData3.length>0" 
                      ref="priceTrend3"
                      :title="lastDate.date"
                      :yTitle="lastData[2].name"
                      :trendItem="futuresData3"
                      chartId="priceTrend3"></priceTrend>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import datatable from './table'
import priceTrend from './line-chart2'
import IndexCard from './indexCard.vue'

export default {
  components: {datatable, priceTrend, IndexCard},
  props: {
    noJump: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lastDate: {
        year: '',
        month: '',
        day: ''
      },
      futuresData1: [],
      futuresData2: [],
      futuresData3: [],
      futuresTag: [
        {
          prop: 'contractCode',
          label: '合约代码',
          slot: true,
          widths: 70
        },
        {
          prop: 'bizDate',
          label: '交易日期',
          widths: 80
        },
        {
          prop: 'yesterdaySettle',
          label: '昨结算',
          widths: 60,
          align: 'right'
        },
        {
          prop: 'todaySettle',
          label: '今结算',
          widths: 60,
          align: 'right'
        },
        {
          prop: 'rate',
          label: '涨跌幅',
          slot: true,
          widths: 60,
          align: 'right'
        },
      ],
      futuresList: [
        {name: '花生（PK）', contractCode: 'PK'},
        {name: '苹果（AP）', contractCode: 'AP'},
        {name: '棉纱（CY）', contractCode: 'CY'},
        {name: '白糖（SR）', contractCode: 'SR'},
        {name: '棉花（CF）', contractCode: 'CF'},
        {name: '纯碱（SA）', contractCode: 'SA'},
        {name: '对二甲苯（PX）', contractCode: 'PX'},
        {name: '菜籽油（OI）', contractCode: 'OI'},
      ],
      lastData: []
    }
  },
  mounted () {
    // this.getLastData()
  },
  methods: {
    toMore (item) {
      if (this.noJump) return
      this.$router.push({ name: 'futures', query: { contractCode: item.contractCode } })
    },
    toMoreRow (row) {
      if (this.noJump) return
      this.$router.push({ name: 'futures', query: { contractCode: row.contractCode, showChart: true } })
    },
    changeData (val) {
      this.lastData = val
      val && this.getDate(this.lastData[0])
    },
    getLastData () {
      this.$http({
        url: this.$http.adornUrl('/crmapi/bas/bulkFutures/lastData'),
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          let array = data.result || []
          this.lastData = array.map(item => {
            let futItem = this.futuresList.find(fut => item.contractCode.includes(fut.contractCode))
            item.name = futItem ? futItem.name : item.contractCode
            return item
          })
          
        } else {
          this.$message.error(data.message)
        }
      })
    },
    getTableData (bizDate) {
      // 花生（PK）
      this.$http({
        url: this.$http.adornUrl("/crmapi/bas/bulkFutures/list"),
        method: "post",
        /*data: {
          isPage: false,
          params: {
            contractCode$LIKE: 'PK',
          },
          data: {
            bizDate
          }
        },*/
        data: {
          "pageNum": 1,
          "pageSize": 20,
          "isPage": false,
          "orderByDesc": "contractCode",
          "data": {
            "labels": "PK",
            "startDate": bizDate, // 具体日期
            "endDate": bizDate // 具体日期
          },
          "params": {
            "contractCode$LIKE": "PK"
          }
        }
      }).then(({ data }) => {
        if (data && data.code === "C0000") {
          this.futuresData1 = data.result.list || []
        } else {
          this.$message.error(data.message);
        }
      })
      // 苹果（AP）
      this.$http({
        url: this.$http.adornUrl("/crmapi/bas/bulkFutures/list"),
        method: "post",
        /*data: {
          isPage: false,
          params: {
            contractCode$LIKE: 'AP',
          },
          data: {
            bizDate
          }
        },*/
        data: {
          "pageNum": 1,
          "pageSize": 20,
          "isPage": false,
          "orderByDesc": "contractCode",
          "data": {
            "labels": "AP",
            "startDate": bizDate, // 具体日期
            "endDate": bizDate // 具体日期
          },
          "params": {
            "contractCode$LIKE": "AP"
          }
        }
      }).then(({ data }) => {
        if (data && data.code === "C0000") {
          this.futuresData2 = data.result.list || []
        } else {
          this.$message.error(data.message);
        }
      })
      // 菜籽粕（RM）
      this.$http({
        url: this.$http.adornUrl("/crmapi/bas/bulkFutures/list"),
        method: "post",
        /*data: {
          isPage: false,
          params: {
            contractCode$LIKE: 'RM',
          },
          data: {
            bizDate
          }
        },*/
        data: {
          "pageNum": 1,
          "pageSize": 20,
          "isPage": false,
          "orderByDesc": "contractCode",
          "data": {
            "labels": "RM",
            "startDate": bizDate, // 具体日期
            "endDate": bizDate // 具体日期
          },
          "params": {
            "contractCode$LIKE": "RM"
          }
        }
      }).then(({ data }) => {
        if (data && data.code === "C0000") {
          this.futuresData3 = data.result.list || []
        } else {
          this.$message.error(data.message);
        }
      })
    },
    getDate (item) {
      if (!item || !item.bizDate) return
      this.lastDate.year = item.bizDate.substr(0, 4)
      this.lastDate.month = item.bizDate.substr(4, 2) + '月'
      this.lastDate.day = item.bizDate.substr(6, 2) + '日'
      this.lastDate.date = item.bizDate.substr(0, 4)+'-'+item.bizDate.substr(4, 2)+'-'+item.bizDate.substr(6, 2);
      this.getTableData(item.bizDate)
    },
    intoCode (row) {
      if (row.sinaFuturesUrl) {
        window.open(row.sinaFuturesUrl)
      }
    }
  }
}
</script>

<style lang="scss">
.contract-code{
  color: #3874F6;
  text-decoration: underline;
  cursor: pointer;
}
.futures-data{
  // width: 1200px;
  margin: auto;
  background: #fff;
  .futures-list{
    display: flex;
    justify-content: space-between;
    padding: 4px 10px;
    background: #E4E7ED;
    .item-data{
      cursor: pointer;
    }
    .item{
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    .value{
      span:first-child{
        padding-right: 10px;
      }
      span:last-child{
        font-size: 14px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/futures-data.vue